import { Router, UrlTree } from '@angular/router';

import { CurrentUserBootstrapResult } from '../current-user.models';
import { CurrentUserStore } from '../current-user.store';

export function redirectForBlockedSession(
  result: CurrentUserBootstrapResult,
  router: Router,
  store: CurrentUserStore,
  requestedUrl?: string
): UrlTree {
  if (result.status === 'unauthenticated') {
    return router.createUrlTree(['/auth/login'], {
      queryParams: requestedUrl ? { returnUrl: requestedUrl } : undefined,
    });
  }

  if (result.status === 'access-denied' || result.status === 'error') {
    return router.parseUrl('/auth/access-denied');
  }

  return router.parseUrl(result.redirectTo ?? store.resolveDefaultRedirectUrl());
}
